import { lazy } from 'react';
import { type RouteObject } from 'react-router-dom';

import { REPORT_ROUTES as REPORT_ROUTE_CONSTANTS } from '../../route-constants';

const DemoReport = lazy(() => import('@~/screens/demo-report'));
const MonthlyReport = lazy(() => import('@~/pages/monthly-report/monthly-report'));
const PtmReport = lazy(() => import('@~/pages/ptm-report/ptm-report'));
const MathFitReportPage = lazy(() => import('@~/pages/mathfit/mathfit-report'));

export const REPORT_ROUTES: RouteObject[] = [
  {
    path: REPORT_ROUTE_CONSTANTS.DEMO_REPORT.PATH,
    element: <DemoReport />,
    handle: {
      pageName: REPORT_ROUTE_CONSTANTS.DEMO_REPORT.NAME,
      isPublicAndPrivate: true,
    },
  },
  {
    path: REPORT_ROUTE_CONSTANTS.MONTHLY_REPORT.RELATIVE_PATH,
    element: <MonthlyReport />,
    handle: {
      pageName: REPORT_ROUTE_CONSTANTS.MONTHLY_REPORT.NAME,
    },
  },
  {
    path: REPORT_ROUTE_CONSTANTS.PTM_REPORT.RELATIVE_PATH,
    element: <PtmReport />,
    handle: {
      pageName: REPORT_ROUTE_CONSTANTS.PTM_REPORT.NAME,
    },
  },
  {
    path: REPORT_ROUTE_CONSTANTS.MATHFIT_REPORT.PATH,
    element: <MathFitReportPage />,
    handle: {
      pageName: REPORT_ROUTE_CONSTANTS.MATHFIT_REPORT.NAME,
    },
  },
  {
    path: REPORT_ROUTE_CONSTANTS.MATHFIT_REPORT_OLD.PATH,
    element: <MathFitReportPage />,
    handle: {
      pageName: REPORT_ROUTE_CONSTANTS.MATHFIT_REPORT_OLD.NAME,
    },
  },
];
